import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {UploadService} from './services/upload.service';
import {HttpClientModule} from '@angular/common/http';
import {VideoComponent} from './components/video/video.component';
import {FormsModule} from '@angular/forms';
import {UploadComponent} from './components/upload/upload.component';
import {CallApiComponent} from './routes/call-api/call-api.component';
import {LocalComponent} from './routes/local/local.component';
import {AppRoutingModule} from "./app-routing.module";

@NgModule({
  declarations: [
    AppComponent,
    VideoComponent,
    UploadComponent,
    CallApiComponent,
    LocalComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
  ],
  providers: [UploadService],
  bootstrap: [AppComponent]
})
export class AppModule { }
